import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleNav, hideContactInfo } from "../../redux/actions/miscActions";
import { clearErrors } from "../../redux/actions/errorActions";
import Cart from "./Cart";
import OrderCost from "./OrderCost";
import { Form, Input, Select } from "antd";

const { TextArea } = Input;
const { Option } = Select;

export class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      adress: "",
      phone: "",
      houseNum: "",
      regio: "",
      message: "",
      email: "",
    };
  }

  componentDidMount = () => {
    this.props.toggleNav(true);
    const { hasProfile, profile } = this.props.profile;
    const { displayName, email } = this.props.user.user;
    const { cart } = this.props.cart;
    if (cart.owner === undefined) {
      this.props.history.push("/");
    }
    if (hasProfile && profile.name) {
      this.setState({
        name: profile.name,
        adress: profile.adress,
        phone: profile.phone,
        houseNum: profile.houseNum,
        regio: profile.regio,
        email,
      });
    } else {
      this.setState({
        name: displayName,
        adress: profile.adress,
        phone: profile.phone,
        houseNum: profile.houseNum,
        regio: profile.regio,
        email,
      });
    }
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  
  handleSelectRegio = (value) => {
    this.setState({
      regio: value,
    });
  };

  componentWillUnmount = () => {
    this.props.hideContactInfo();
    this.props.clearErrors();
  };

  render() {
    const { name, adress, phone, houseNum, regio, message, email } = this.state;
    const { isContactInfoVisible } = this.props.misc;
    const { hasErrors } = this.props.error;
    const gebieden = [
      <Option key="PBM">Paramaribo</Option>,
      <Option key="CM">Commewijne</Option>,
      <Option key="WN">Wanica</Option>,
      <Option key="PR">Para</Option>,
      <Option key="BR">Brokopondo</Option>,
      <Option key="OO">Andere</Option>,      
    ];
    return (
      <div className="checkout-page">
        <div className="left">
          <Form layout="vertical">
          <Form.Item
              label="Naam"
              validateStatus={name === null && hasErrors ? "error" : ""}
              help={name === null && hasErrors ? "Vul uw naam in" : null}
              required={true}
            >
              <Input name="name" onChange={this.handleChange} value={name} />
            </Form.Item>

            <Form.Item
              label="Adres"
              required={true}
              validateStatus={adress === undefined && hasErrors ? "error" : ""}
              help={
                adress === undefined && hasErrors ? "Vul uw adres in" : null
              }
            >
              <Input
                name="adress"
                onChange={this.handleChange}
                value={adress}
              />
            </Form.Item>

            <Form.Item
              label="Huisnummer"
              required={true}
              validateStatus={
                houseNum === undefined && hasErrors ? "error" : ""
              }
              help={
                houseNum === undefined && hasErrors ? "Uw huisnummer" : null
              }
            >
              <Input
                name="houseNum"
                onChange={this.handleChange}
                value={houseNum}
              />
            </Form.Item>

            <Form.Item
              label="Buurt"
              required={true}
              validateStatus={regio === undefined && hasErrors ? "error" : ""}
              help={
                regio === undefined && hasErrors ? "Selecteer uw regio" : null
              }
            >
              <Select
                placeholder="Selecteer uw buurt"
                onChange={this.handleSelectRegio}
                value={regio}
              >
                {gebieden}
              </Select>
            </Form.Item>

            <Form.Item
              label="Email"
              required={true}
              validateStatus={email === undefined && hasErrors ? "error" : ""}
              help={
                email === undefined && hasErrors
                  ? "Vul uw email adres in"
                  : null
              }
            >
              <Input name="email" onChange={this.handleChange} value={email} />
            </Form.Item>

            <Form.Item
              label="Contact nummer"
              required={true}
              validateStatus={phone === undefined && hasErrors ? "error" : ""}
              help={
                phone === undefined && hasErrors
                  ? "Vul uw contact nummer in"
                  : null
              }
            >
              <Input name="phone" onChange={this.handleChange} value={phone} />
            </Form.Item>


            <Form.Item label="Bericht">
              <TextArea
                name="message"
                onChange={this.handleChange}
                value={message}
              />
            </Form.Item>
          </Form>
        </div>
        <div className="right">
          <OrderCost
            cart={this.props.cart}
            products={this.props.products}
            cust={this.state}
            user={this.props.user}
            regio={regio}
          />
          {isContactInfoVisible ? (
            <div className="mobile">
              <div className="left">
                <Form layout="vertical">
                <Form.Item
                  label="Naam"
                  validateStatus={name === null && hasErrors ? "error" : ""}
                  help={name === null && hasErrors ? "Vul uw naam in" : null}
                  required={true}
                >
                  <Input
                    name="name"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Form.Item>

                <Form.Item
                  label="Adres"
                  required={true}
                  validateStatus={
                    adress === undefined && hasErrors ? "error" : ""
                  }
                  help={
                    adress === undefined && hasErrors ? "Vul uw adres in" : null
                  }
                >
                  <Input
                    name="adress"
                    onChange={this.handleChange}
                    value={adress}
                  />
                </Form.Item>

                <Form.Item
                  label="Huisnummer"
                  required={true}
                  validateStatus={
                    houseNum === undefined && hasErrors ? "error" : ""
                  }
                  help={
                    houseNum === undefined && hasErrors ? "Uw huisnummer" : null
                  }
                >
                  <Input
                    name="houseNum"
                    onChange={this.handleChange}
                    value={houseNum}
                  />
                </Form.Item>

                <Form.Item
                  label="Buurt"
                  required={true}
                  validateStatus={
                    regio === undefined && hasErrors ? "error" : ""
                  }
                  help={
                    regio === undefined && hasErrors
                      ? "Selecteer uw regio"
                      : null
                  }
                >
                  <Select
                    placeholder="Selecteer uw buurt"
                    onChange={this.handleSelectRegio}
                    value={regio}
                  >
                    {gebieden}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Email"
                  required={true}
                  validateStatus={
                    email === undefined && hasErrors ? "error" : ""
                  }
                  help={
                    email === undefined && hasErrors
                      ? "Vul uw email adres in"
                      : null
                  }
                >
                  <Input
                    name="email"
                    onChange={this.handleChange}
                    value={email}
                  />
                </Form.Item>

                <Form.Item
                  label="Contact nummer"
                  required={true}
                  validateStatus={
                    phone === undefined && hasErrors ? "error" : ""
                  }
                  help={
                    phone === undefined && hasErrors
                      ? "Vul uw contact nummer in"
                      : null
                  }
                >
                  <Input
                    name="phone"
                    onChange={this.handleChange}
                    value={phone}
                  />
                </Form.Item>

                  <Form.Item label="Bericht">
                    <TextArea
                      name="message"
                      onChange={this.handleChange}
                      value={message}
                    />
                  </Form.Item>
                </Form>{" "}
              </div>
            </div>
          ) : null}
          <Cart />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  products: state.products,
  profile: state.profile,
  user: state.user,
  misc: state.misc,
  error: state.error,
});

export default connect(mapStateToProps, { toggleNav, hideContactInfo, clearErrors })(
  Checkout
);
